module.exports = __webpack_public_path__ + "static/media/02.19109fdf.mp3";